import { ICorporateEvent, ICorporateEventVendor } from "../../interfaces/corporateEvent";

export const transformCorporateEventsListingResponse = (
	corporateEventVendors: ICorporateEventVendor[],
): ICorporateEvent[] => {
	return corporateEventVendors.map((event) => {
		return transformCorporateEventDetailResponse(event);
	});
};

export const transformCorporateEventDetailResponse = (
	corporateEventVendor: ICorporateEventVendor,
): ICorporateEvent => {
	const { corporateEvent, messages, totalUnreadMessageCount, vendorSendBirdId, ...vendor } =
		corporateEventVendor;
	return { ...corporateEvent, vendor, messages, totalUnreadMessageCount, vendorSendBirdId };
};

export const extractVendorIdsFromCorporateEvent = (corporateEvent: ICorporateEventVendor[]): string[] => {
	return corporateEvent.map((event) => event.vendorId);
};
